module.exports = __webpack_public_path__ + "media/application/images/demo/wall1-3610c24bd0093ea9514c37ad11450be5.jpg";